import { useLayoutEffect, useRef } from 'react';
import { nextTriviaFitScale, TRIVIA_FIT_MIN_SCALE } from './triviaFit';

export function useTriviaFit(deps: unknown[] = []) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const root = ref.current;
    if (!root) return;
    const els = [...root.querySelectorAll<HTMLElement>('[data-base]')];
    let k = 1;
    const apply = () => {
      root.style.setProperty('--trivia-fit', k.toFixed(3));
      els.forEach((el) => {
        const base = Number(el.dataset.base);
        if (!Number.isFinite(base)) return;
        el.style.fontSize = `${(base * k).toFixed(1)}px`;
      });
    };
    const overflow = () => {
      const prev = root.style.overflow;
      root.style.overflow = 'auto';
      const scrolled =
        root.scrollHeight > root.clientHeight + 1 ||
        root.scrollWidth > root.clientWidth + 1;
      const box = root.getBoundingClientRect();
      const childOverflow = [...root.children].some((child) => {
        const c = child.getBoundingClientRect();
        return c.bottom > box.bottom + 1 || c.right > box.right + 1;
      });
      root.style.overflow = prev;
      return scrolled || childOverflow;
    };
    apply();
    while (overflow() && k > TRIVIA_FIT_MIN_SCALE + 0.001) {
      k = nextTriviaFitScale(k);
      apply();
    }
    root.dataset.scale = k.toFixed(2);
    // deps intentionally provided by caller
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return ref;
}
